import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const Gone = () => {
  const location = useLocation();

  useEffect(() => {
    const prevTitle = document.title;
    document.title = "410 Gone — Page permanently removed";

    const setMeta = (name: string, content: string) => {
      let el = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", name);
        document.head.appendChild(el);
      }
      const prev = el.getAttribute("content");
      el.setAttribute("content", content);
      return () => {
        if (prev === null) el?.remove();
        else el?.setAttribute("content", prev);
      };
    };

    const restoreRobots = setMeta("robots", "noindex, nofollow");
    const restoreDesc = setMeta(
      "description",
      "This page has been permanently removed (HTTP 410 Gone). Please visit esrelectric.ca for current content."
    );

    // Remove canonical so search engines don't keep this URL alive
    const canonical = document.querySelector('link[rel="canonical"]');
    const canonicalParent = canonical?.parentNode;
    const canonicalNext = canonical?.nextSibling;
    canonical?.remove();

    console.warn("410 Gone: legacy URL removed:", location.pathname);

    return () => {
      document.title = prevTitle;
      restoreRobots();
      restoreDesc();
      if (canonical && canonicalParent) canonicalParent.insertBefore(canonical, canonicalNext ?? null);
    };
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted px-6">
      <div className="max-w-xl text-center">
        <h1 className="mb-4 text-4xl font-bold">410 Gone</h1>
        <p className="mb-2 text-xl text-muted-foreground">
          This page has been permanently removed.
        </p>
        <p className="mb-6 text-sm text-muted-foreground">
          The URL <code className="rounded bg-background px-1.5 py-0.5">{location.pathname}</code>{" "}
          was part of an old website and no longer exists. Search engines should de-index it.
        </p>
        <a href="/" className="text-primary underline hover:text-primary/90">
          Visit ESR Electric Ltd home
        </a>
      </div>
    </div>
  );
};

export const isLegacyGonePath = (pathname: string): boolean => {
  return (
    /\/20\d{2}\/\d{2}\/\d{2}\//.test(pathname) ||
    /\/20\d{2}\//.test(pathname) ||
    /^\/tag\//.test(pathname) ||

    /^\/feed\/?$/.test(pathname) ||
    /\/feed\/?$/.test(pathname) ||
    /^\/wp-admin\//.test(pathname) ||
    /^\/wp-admin\/?$/.test(pathname) ||
    /^\/xmlrpc\.php$/.test(pathname)
  );
};

export default Gone;
